export default __webpack_public_path__ + "static/media/r.09fa6d84.mp4";